import React from "react";
import styles from "./QuickFilterBar.module.scss";
import Cross from "assets/Icon_Close_Filter.png";
import {FilterDetails} from "helpers/useGetFilterDetails";
import classNames from "classnames";

type Props = {
  filterString: string;
  setFilters(filterString: string): void;
  filterDetails: FilterDetails;
  noWidthContent?: boolean;
  preFilterSubmitCb?: () => void;
  displayOnly?: boolean; // If true, it will not show the remove button
};

function QuickFilterBar(props: Props): JSX.Element {
  const {filterString, setFilters, filterDetails, noWidthContent, preFilterSubmitCb, displayOnly = false} = props;
  const filters = filterString === "reset" ? "" : filterString;
  if (filterDetails.data) {
    const generalPairs = Object.values(filterDetails.data.general.datasetFilters).flatMap(
      (filter) => filter.possibleValues
    );

    /*
    const reviewFeedPairs = Object.values(filterDetails.data.review ?? {}).flatMap(
      (filter) => filter.PossibleValues
    );

    const commentAnalysisPairs = Object.values(filterDetails.data.comment ?? {}).flatMap((filter) =>
      Object.values(filter).map((x) => x.possibleValues)
    );
    */

    const timePairs = Object.values(filterDetails.data.general.timePeriodFilters).flatMap(
      (filter) =>
        filter.possibleValues.map((x) => {
          return {...x, Value: `${x.value?.startDate}__${x.value?.endDate}`};
        })
    );
    //filter.possibleValues);

    // const pairs = [generalPairs, timePairs, reviewFeedPairs, commentAnalysisPairs].flat();

    const filterPairs = filters ? filters.split("||").map((x) => x.split("::")) : [];

    const removeFilter = (val: string) => {
      preFilterSubmitCb && preFilterSubmitCb();
      const newPairs = filterPairs.filter(([hierarchy]) => hierarchy !== val);

      const newString = newPairs.map((x) => x.join("::")).join("||");
      setFilters(newString || "reset");
    };

    return (
      <div
        className={classNames(styles.container, {
          [styles.negWidth]: !noWidthContent,
        })}
      >
        {filterString !== "reset" && (
          <React.Fragment>
            {!displayOnly && <span>Filters:</span>}
            <div>
              {filterPairs.map(([hierarchy, value]) => {
                const timeMatch = timePairs.find((x) => x.Value === value);
                const generalMatch = generalPairs.find((x) => x.value === value);
                let displayValue = value;
                if (timeMatch) {
                  displayValue = timeMatch.label;
                } else if (generalMatch) {
                  displayValue = generalMatch.label;
                } else if (hierarchy === "responsestatus") {
                  switch (value) {
                    case "null":
                      displayValue = "Not responded";
                      break;
                    case "NA":
                      displayValue = "Cannot Respond";
                      break;
                    case "Posted":
                      displayValue = "Responded";
                      break;
                    default:
                      displayValue = value;
                      debugger
                      break;
                  }
                } else if (value === "") {
                  displayValue = "Online Survey";
                }
                return <FilterLozenge
                  key={hierarchy}
                  filterName={displayValue}
                  onClick={() => removeFilter(hierarchy)}
                  displayOnly={displayOnly}
                />;
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  return <div className={styles.container}>Filters </div>;
}

function FilterLozenge(props: { filterName: string; onClick(): void , displayOnly?: boolean}): JSX.Element {
  const {filterName, onClick, displayOnly} = props;
  if (onClick && !displayOnly) {
    return (
        <button onClick={onClick} className={styles.filterLozenge}>
          <img src={Cross} alt=""/>
          {filterName}
        </button>
    );
  } else {
    return (
        <div className={styles.filterLozenge} style={{paddingLeft: "10px"}}>
          {filterName}
        </div>
    );
  }

}

export default QuickFilterBar;
